import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const peopleProfilesEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-people-profiles-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
